import { CDPFieldsEnums } from '@/modules/CDP/shared/contacts/domain/enums/CDPFieldsEnums'
import ActivityLogsUseCases from '@/modules/Config/ActivityLogs/application/ActivityLogsUseCases'
import { ActivityActionTypeEnum, ActivityLogModuleTypeEnum, dataToWriteActivityLog } from '@/modules/Config/ActivityLogs/domain/ActivityLogsController'
import ActivityLogsController from '@/modules/Config/ActivityLogs/infrastructure/controllers/ActivityLogs.controller'
import StatusUseCases from '@/modules/Statuses/application/StatusUseCases'
import { Status } from '@/modules/Statuses/domain/Status'
import StatusController from '@/modules/Statuses/infrastructure/controllers/Status.controller'
import Colors from '@/utils/Colors'
import EmitToast from '@/utils/EmitToast'
import operations from '@/utils/operations'
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  props: {
    placeholder: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    value: {
      type: String
    }
  },
  computed: {
    ...mapState('UserStore', ['token', 'user']),
    ...mapState('AppStore', ['selectedApp']),
    selectedItemLabel (): string {
      if (this.loading) return this.placeholder
      return this.selectedItem ? this.selectedItem[CDPFieldsEnums.NAME] : this.placeholder
    },
    labelStyle (): string {
      return this.selectedItem
        ? `color: ${this.$vuetify.theme.dark ? Colors.white : Colors.black}`
        : `color: ${Colors.simpleGrey}`
    },
    itemStyle (): string {
      return this.$vuetify.theme.dark
        ? `background-color: ${Colors.morningCoffee}; border-color: ${Colors.grey}`
        : `background-color: ${Colors.white}; border-color: ${Colors.light4}`
    },
    dependenciesItems (): Status[] {
      if (!this.selectedItem) return this.items
      return this.items.filter((item: Status) => {
        if (!item.dependencies || item.dependencies.length === 0) {
          return true
        }
        const dependenciesIds = item.dependencies.map(dep => dep._id)
        return dependenciesIds.includes(this.selectedItem._id || '')
      })
    }
  },
  mounted () {
    this.getStatuses()
  },
  data () {
    return {
      selectedItem: '',
      loading: false,
      items: [],
      open: false,
      statusController: new StatusController(),
      activityLogsController: new ActivityLogsController()
    }
  },
  methods: {
    openMenu (): void {
      if (!this.disabled) {
        this.open = !this.open
      }
    },
    statusBallStyle (item: Status): string {
      return `background-color: ${item.color};`
    },
    itemLabel (item: Status): string {
      return item[CDPFieldsEnums.NAME]
    },
    async getStatuses () {
      try {
        this.loading = true
        const data = {
          app: this.selectedApp?.uuid,
          token: this.token,
          pagination: {
            offset: 0,
            limit: 200
          }
        }
        const response = await StatusUseCases.getStatuses(this.statusController, data)
        if (Array.isArray(response)) {
          this.items = response
          this.items.forEach((item: Status) => {
            item.name = operations.checkTranslation(item.name)
          })
          this.setValue()
        } else EmitToast.emitErrors(response)
        this.loading = false
      } catch (e) {
        console.error(e)
        this.loading = false
      }
    },
    selectItem: debounce(function (item: any) {
      this.writeActivityLog(this.selectedItem?.name || '', item.name || '')
      this.selectedItem = item
      const value: string = this.selectedItem?._id
      this.$emit('input', value)
    }, 600),
    setValue () {
      const item: Status = this.items.find((item: Status) => item._id === this.value)
      this.selectedItem = item
    },
    async writeActivityLog (oldValue: string, newValue: string): Promise<void> {
      const data: dataToWriteActivityLog = {
        token: this.token,
        updateInput: {
          appUUID: this.selectedApp?.uuid,
          module: ActivityLogModuleTypeEnum.CDP,
          action: ActivityActionTypeEnum.CONTACT_STATUS_UPDATE,
          user: {
            id: this.user.uuid,
            name: this.user.name + ' ' + this.user.lastName
          },
          payload: {
            field: 'status',
            newValue: newValue,
            oldValue: oldValue
          }
        }
      }
      await ActivityLogsUseCases.writeActivityLog(this.activityLogsController, data)
    }
  },
  watch: {
    value () {
      this.setValue()
    }
  }
}
